export default __webpack_public_path__ + "static/media/logistics.05f0a532.svg";